import { ref, watch } from 'vue'
import { createSharedComposable } from '@vueuse/core'

export enum MainHeaderItems {
  SETTINGS_MAIN_PAGE,
  NOTIFICATION_CENTER,
  TRANSMISSION_LIST,
}

const useActiveMainHeaderItem = () => {
  const currentSelectedItem = ref<MainHeaderItems>()
  const currentExtraQuery = ref<string>()

  const updateCurrentSelectedItem = (item?: MainHeaderItems, extraQuery?: string) => {
    currentExtraQuery.value = extraQuery
    currentSelectedItem.value = currentSelectedItem.value === item ? undefined : item
  }
  const onCurrentSelectedItemUpdated = ref<Set<(selectedItem?: MainHeaderItems, extraQuery?: string) => void>>(
    new Set()
  )

  watch(currentSelectedItem, (selectedItem) => {
    for (const fn of onCurrentSelectedItemUpdated.value) fn(selectedItem, currentExtraQuery.value)

    currentExtraQuery.value = undefined
  })

  const avatarNameContainerWidthGap = ref<number>(0)

  return {
    currentSelectedItem,
    updateCurrentSelectedItem,
    onCurrentSelectedItemUpdated,
    avatarNameContainerWidthGap,
  }
}

export const useSharedActiveMainHeaderItem = createSharedComposable(useActiveMainHeaderItem)
